export enum IdentifierCode {
  // encounter
  encounterMedicalAidAuthorizationCode = 'identifier.encounter.hospitalization.authorizationcode',
  encounterMedicalAidAuthorizationDate = 'identifier.encounter.hospitalization.authorizationdate',
  /**
   * Used to identify and link to the medical aid details that were active at the time of admission
   * creation
   */
  encounterHospitalizationSchemeCode = 'identifier.encounter.hospitalization.extension.schemecode',
  /**
   * Used to identify and link to the medical aid details that were active at the time of admission
   * creation
   */
  encounterHospitalizationSubscriberId = 'identifier.encounter.hospitalization.extension..subscriberid',
  /**
   * Used to identify and link to the medical aid details that were active at the time of admission
   * creation
   */
  encounterHospitalizationDependentCode = 'identifier.encounter.hospitalization.extension.dependent',

  // practitioner
  registrationNumber = 'identifier.practitioner.registrationnumber',
  ampathMnemonic = 'identifier.practitioner.external.ampathMnemonic',

  // device
  deviceType = 'identifier.device.type',

  // service-request
  serviceRequestPerformer = 'identifier.servicerequest.performer',

  // any type of person
  southAfricanIdNumber = 'identifier.southafricanidnumber',
  namibianIdNumber = 'identifier.namibianidnumber',
  passportNumber = 'identifier.passportnumber',

  // Medical aid codes
  membershipNumber = 'identifier.patient.coverage.subscriberid',
  schemeCode = 'identifier.patient.coverage.schemecode',
  schemeShortName = 'identifier.patient.coverage.schemeshortname',
  dependantCode = 'identifier.patient.coverage.dependent',
  /**
   * scheme code applies to organizations with a type of `ins` (Insurance)
   */
  organizationSchemeCode = 'identifier.organization.type.insurance.schemeCode',

  /**
   * Used to identify medication requests that were created in the same script
   */
  medicationRequestGroupIdentifier = 'identifier.medicationrequest.groupidentifier',
  /**
   * Used to identify medication statement that were created in the same script
   */
  medicationStatementGroupIdentifier = 'identifier.medicationstatement.groupidentifier',

  claimInvoiceNumber = 'identifier.claim.invoicenumber',

  chargeItemConsumableCode = 'identifier.chargeitem.medprax.materialcode',

  conversation = 'identifier.communication.conversation',
  conversationMessage = 'identifier.communication.conversation.message',
  locationCapacity = 'identifier.location.capacity',
  locationAcuity = 'identifier.location.acuity',
  conversationMessageType = 'identifier.communication.conversation.message.type',
  conversationParticipant = 'identifier.communication.conversation.participant',
  conversationAlert = 'identifier.communication.conversation.alert',
  libraryTemplateId = 'identifier.library.template.id',

  carePlanActivityDate = 'identifier.careplan.activity.scheduledPeriod',

  patientMasterIndexId = 'identifier.patient.pmi',
}

export enum PersonIdentityCode {
  saIdNumber = IdentifierCode.southAfricanIdNumber,
  namibiaIdNumber = IdentifierCode.namibianIdNumber,
  passportNumber = IdentifierCode.passportNumber,
}
